import { Queue } from '../../queue';
var CacheHandler = /** @class */ (function () {
    function CacheHandler() {
        this.projectionCache = {};
    }
    CacheHandler.get = function () {
        if (CacheHandler._cacheHandler == null) {
            CacheHandler._cacheHandler = new CacheHandler();
        }
        return CacheHandler._cacheHandler;
    };
    /**
     * Handle the caching of promises, i.e.:
     *
     *  * Evict the cache for the given key when evict is passed.
     *  * Return the cached value if it exists.
     *  * Check if there is already a request underway for the given key. If so return the original
     *    observable (which is shared and can be used at multiple locations).
     *  * If there is no cached value and no request underway, run the request and save it until it
     *    is finished so there are no duplicate requests.
     */
    CacheHandler.prototype.handle = function (options) {
        var _this = this;
        var returnValue;
        var cache = options.cacheStrategy;
        var key = options.key;
        if (options.evict) {
            cache.evict(options.key);
        }
        var cachedValue = cache.get(key);
        if (cachedValue) {
            returnValue = Promise.resolve().then(function () { return cachedValue; });
        }
        else {
            if (this.projectionCache[key] == null) {
                this.projectionCache[key] = new Queue();
            }
            if (this.projectionCache[key].length === 0) {
                options
                    .resolveData()
                    .then(function (result) {
                    cache.set(key, result, options.ttl);
                    _this.projectionCache[key].call({
                        error: false,
                        result: result,
                    });
                    _this.projectionCache[key].clear();
                })
                    .catch(function (err) {
                    _this.projectionCache[key].call({
                        error: true,
                        result: err,
                    });
                });
            }
            returnValue = new Promise(function (resolve, reject) {
                _this.projectionCache[key].push(function (result) {
                    if (result.error) {
                        reject(result.result);
                    }
                    else {
                        resolve(result.result);
                    }
                });
            });
        }
        return returnValue;
    };
    return CacheHandler;
}());
export { CacheHandler };
//# sourceMappingURL=data:application/json;base64,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